import { render, staticRenderFns } from "./order.vue?vue&type=template&id=26fb6eb4&scoped=true&"
import script from "./order.vue?vue&type=script&lang=js&"
export * from "./order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fb6eb4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26fb6eb4')) {
      api.createRecord('26fb6eb4', component.options)
    } else {
      api.reload('26fb6eb4', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=26fb6eb4&scoped=true&", function () {
      api.rerender('26fb6eb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/open3d/order.vue"
export default component.exports